import React from 'react'
import Button from '../../../Components/commonButton/commonButton'
import TextField from '../../../Components/textField/textField'
import Api from '../../../services/api'
import Alert from '../../../Components/alert/Alert'
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import "../general.css"

export default class AddRefuseReason extends React.Component {
    state = {
      show: false,
      reason: null,
      id: null,
      message: "",
      reload: false,
      code:null,
      notification: false,
      notification_type: 'success',
      notification_message: ''
    }
  
  sendData = () => {
    const { reason,code} = this.state
    if((reason !== "" && reason !== null) && (code !== null && code !== "")){
      Api.post('/refuse-reasons/', {
        description: this.state.reason,
        code: this.state.code,
      }).then((res) => {
        this.setState({notification: true, notification_message: "Motivo de refugo cadastrado com sucesso!"});
          setTimeout(()=>{
            return window.location.reload();
          },2000)
      }).catch(err=>{
          this.setState({show:true,message:""+err.message,reload:true})
      })

    } else {
      this.setState({ message: "Necessário preencher todos os campos.", show: true })
    }
  }

  callbackfunction = () => { this.setState({ show: false }) }
  callBackReason   = (child) => { this.setState({ reason: child }) }
  callBackCode     = (value) => { this.setState({ code: value }) }


  render() {
    let { show, message, reload, notification, notification_message, notification_type } = this.state
    return (
      <div className='box'>
        <div className="input_fields_add_refuse_reason form">
        {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
        <h4>Adicionar Refugo</h4>
          {show ? <Alert show={show} message={message} parentCallback={this.callbackfunction} reload={reload} /> : null}
          <div className='inputs'>
            <div className='tf1AddRefReason element'><TextField section={true} focus={true} title="Código" max={3} value={this.state.code} validationType="int" parentCallback={this.callBackCode} /></div>
            <div className='tf2AddRefReason element'><TextField title="Descrição" max={45} value={this.state.reason} validationType="varchar" parentCallback={this.callBackReason} /></div>
          </div>
          <div className="btnAddRefReason submitButton"><Button title="Adicionar" icon="add" parentCallback={this.sendData} /></div>
        </div>
      </div>
    );
  }
}